import { render, staticRenderFns } from "./VProposalListItemLinks.vue?vue&type=template&id=d3bab702&scoped=true&"
import script from "./VProposalListItemLinks.vue?vue&type=script&lang=js&"
export * from "./VProposalListItemLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3bab702",
  null
  
)

export default component.exports